import { Component, computed, DestroyRef, effect, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { provideIcons } from '@ng-icons/core';
import { lucideEllipsisVertical, lucidePen, lucidePlus, lucideTrash } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { filter } from 'rxjs';

import { Cartographie } from '../../../../cartographie/models/cartographie.model';
import { ConfirmDialogComponent } from '../../../../shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { SidepanelService } from '../../../../shared/components/sidepanel/sidepanel.service';
import { TrierParPipe } from '../../../../shared/pipes/trier-par.pipe';
import { Site } from '../../model/site.model';
import { SiteStore } from '../../store/site.store';
import { FormSiteComponent } from '../form/form-site.component';

@Component({
  selector: 'app-gestion-sites',
  imports: [HlmCardImports, HlmDropdownMenuImports, HlmButtonImports, HlmTableImports, HlmIconImports, TrierParPipe],
  templateUrl: './gestion-sites.component.html',
  providers: [provideIcons({ lucideEllipsisVertical, lucidePlus, lucidePen, lucideTrash })],
})
export class GestionSitesComponent {
  readonly #siteStore = inject(SiteStore);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #dialog = inject(HlmDialogService);
  readonly #destroyRef = inject(DestroyRef);

  readonly cartographie = input.required<Cartographie>();

  readonly sites = computed(() => this.#siteStore.entities());

  constructor() {
    effect(() => this.#siteStore.charger(this.cartographie().id));
  }

  ajouterSite() {
    this.#sidepanelService.setComponentToDisplay(
      'Ajouter un Centre de Formation',
      FormSiteComponent,
      `Créez des Centres de Formation et rattachez-les à leur région pour permettre de construire l’offre régionale.`,
      { cartographie: this.cartographie() },
    );
    this.#sidepanelService.open();
  }

  modifierSite(site: Site) {
    this.#sidepanelService.setComponentToDisplay(
      'Modifier le Centre de Formation',
      FormSiteComponent,
      `Vous pouvez modifier le Centre de Formation sélectionné.`,
      { cartographie: this.cartographie(), site: this.#siteStore.entityMap()[site.id] },
    );
    this.#sidepanelService.open();
  }

  supprimerSite(site: Site) {
    const dialogRef = this.#dialog.open(ConfirmDialogComponent, {
      context: {
        titre: `Êtes-vous sûr de vouloir supprimer ${site.region} - ${site.nom} ?`,
        contenu: `Vous êtes sur le point de supprimer <b>${site.region} - ${site.nom}</b>. Cette action est définitive et ne peut pas être annulée.`,
      },
    });
    dialogRef.closed$
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        filter((result: boolean) => result),
      )
      .subscribe(async () => this.#siteStore.supprimer(site.id));
  }
}
